import { ExperimentNames } from 'common/experiments/ExperimentDefinitions';
import { IConfigs } from 'src/shef-global-state/shefGlobalState';

export interface ExperimentDefinition {
  flagName?: keyof IConfigs | undefined;
  treatmentVariant?: string;
  logExposureImmediately?: boolean;
}

export const EXPERIMENT_REGISTRY: Partial<Record<ExperimentNames, ExperimentDefinition>> = {
  [ExperimentNames.LP_DISH_STORIES]: { flagName: 'lpDishStoriesEnabled' },
  [ExperimentNames.LP_FULL_BLEED_VIDEO]: { flagName: 'lpFullBleedVideoEnabled' },
  [ExperimentNames.LP_HOW_IT_WORKS]: { flagName: 'lpHowItWorksEnabled' },
  [ExperimentNames.INTAKE_OPTIMIZATION]: { flagName: 'intakeOptimizationEnabled' },
  [ExperimentNames.INTAKE_HOUSEHOLD_CONSOLIDATION_V2]: { flagName: 'intakeHouseholdConsolidationV2Enabled' },
  [ExperimentNames.INTAKE_SETTINGS_BEFORE_CALENDAR]: { flagName: 'intakeSettingsBeforeCalendarEnabled' },
  [ExperimentNames.DEFAULT_PLAN_UPDATE]: { flagName: 'defaultPlanUpdateEnabled' },
  [ExperimentNames.SIGN_UP_GATE_REDESIGN_V2]: { flagName: 'signUpGateRedesignEnabled' },
  [ExperimentNames.SIDES_CATEGORY_CAROUSEL]: { flagName: 'sidesCategoryCarouselEnabled' },
  [ExperimentNames.FAVORITES_V2]: { flagName: 'favoritesV2Enabled' },
  [ExperimentNames.LEAD_CAPTURE_MODAL_V2]: { flagName: 'leadCaptureModalEnabled' },
  [ExperimentNames.MEAL_PLAN_CHECKOUT_REVAMP_V3]: { flagName: 'mealPlanCheckoutRevampV1Enabled' },
  [ExperimentNames.EXPRESS_CHECKOUT_V2]: { flagName: 'expressCheckoutV1Enabled' },
  [ExperimentNames.VARIABLE_SERVICE_FEE]: { flagName: 'variableServiceFeeEnabled' },
  [ExperimentNames.MARKETPLACE_VARIABLE_SERVICE_FEE]: { flagName: 'marketplaceVariableServiceFeeEnabled' },
  [ExperimentNames.BULK_DISCOUNT]: { logExposureImmediately: true },
  [ExperimentNames.WSS_FLEXIBLE_SERVINGS_V2]: { flagName: 'wssFlexibleServingsV2Enabled' },
  [ExperimentNames.WSS_FLEXIBLE_SERVINGS_V3]: { flagName: 'wssFlexibleServingsV3Enabled' },
  [ExperimentNames.WSS_REUSABLE_OPT_IN]: { flagName: 'wssReusableOptInEnabled' },
  [ExperimentNames.WSS_DESSERTS_PLACEMENT]: {},
  [ExperimentNames.PRICING_CURVE_BAY_LA_V2]: {},
  [ExperimentNames.PRICING_CURVE_NY_V2]: {},
  [ExperimentNames.PRICING_CURVE_CHI_V2]: {},
  [ExperimentNames.PRICING_CURVE_SEA_V2]: {},
  [ExperimentNames.PRICING_CURVE_BOS_V2]: {},
  [ExperimentNames.PRICING_CURVE_DC_V2]: {},
  [ExperimentNames.PRICING_CURVE_AUS_V2]: {},
  [ExperimentNames.REUSABLE_PACKAGING_LA]: { flagName: 'reusablePackagingLaEnabled' },
  [ExperimentNames.REUSABLE_PACKAGING_SEA]: { flagName: 'reusablePackagingSeaEnabled' },
  [ExperimentNames.HIDE_HOMEPAGE_ONE_TIME_TX]: { flagName: 'hideHomepageOneTimeTxEnabled' },
};
